import { partnerServices } from "../../config/axios";
import { LOADING_UPDATE_ADD_VOUCHER_WIRE, NETWORK_ERROR_UPDATE_ADD_VOUCHER_WIRE, RESET_UPDATE_ADD_VOUCHER_WIRE, UPDATE_ADD_VOUCHER_WIRE_FAILED, UPDATE_ADD_VOUCHER_WIRE_SUCCESS } from "../types"

export const resetUpdateAddVoucherWire = () => {
    return { type: RESET_UPDATE_ADD_VOUCHER_WIRE };
}

export const updateOrAddVoucherWire = ( request, authtoken ) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATE_ADD_VOUCHER_WIRE });
    await partnerServices
    .post('updateOrAddVoucherWire', request, { headers: { AuthToken: authtoken } } )
    .then( res => {
        switch( res.data.status ) {
            case 'success': 
                dispatch({ type: UPDATE_ADD_VOUCHER_WIRE_SUCCESS, payload: res.data });
                break;
            default: 
                dispatch({ type: UPDATE_ADD_VOUCHER_WIRE_FAILED, payload: res.data })
                break;
        }
    } )
    .catch( err => {
        dispatch({ type: NETWORK_ERROR_UPDATE_ADD_VOUCHER_WIRE, payload: err });
    } )
}